var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MS_IN_ONE_MINUTE } from '../const/math';
import { BinaryStorage, Metrika } from '../../lib/classes';
import { defaultSettings, STORAGE_KEY, REMOTE_URL, REMOTE_FILE, VERSION } from './state';
var loadTime = Date.now();
var storage = new BinaryStorage(STORAGE_KEY, defaultSettings);
if (DEVELOPMENT) {
    console.log({ settings: storage.encode(defaultSettings) });
    // @ts-ignore (эта ф-я важна для CLI)
    window['getDefaultSettings'] = function () {
        return { defaultSettings: Object.assign({}, defaultSettings), REMOTE_URL: REMOTE_URL, REMOTE_FILE: REMOTE_FILE, VERSION: VERSION, STORE: STORE };
    };
    // @ts-ignore (эта ф-я важна для CLI)
    window['encodeSettings'] = function (settings) { return storage.encode(settings); };
    // @ts-ignore (эта ф-я важна для CLI)
    window['decodeSettings'] = function (text) { return storage.decode(text); };
    // @ts-ignore
    window['clearSettings'] = function () {
        localStorage.removeItem(STORAGE_KEY);
        location.reload();
    };
    // @ts-ignore
    window['checkSettings'] = function () { return __awaiter(void 0, void 0, void 0, function () {
        var remote, locale, diff, key;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, safeLoadSettings()];
                case 1:
                    remote = _a.sent();
                    locale = defaultSettings;
                    console.group('Настройки');
                    console.log("file: ".concat(REMOTE_URL, "/").concat(REMOTE_FILE));
                    if (!remote) {
                        printInstruction_1('Необходимо сохранить настрйки на сервере!', locale);
                        console.groupEnd();
                        return [2 /*return*/, false];
                    }
                    console.log("remote: ".concat(storage.encode(remote), " (").concat(JSON.stringify(remote), ")"));
                    console.log("locale: ".concat(storage.encode(locale), " (").concat(JSON.stringify(locale), ")"));
                    if (JSON.stringify(remote) === JSON.stringify(locale)) {
                        console.log('Все ОК!');
                        console.groupEnd();
                        return [2 /*return*/, true];
                    }
                    else {
                        diff = {};
                        for (key in locale) {
                            if (remote[key] !== locale[key]) {
                                diff[key] = locale[key];
                            }
                        }
                        console.log("diff: ".concat(JSON.stringify(diff)));
                        printInstruction_1('Необходимо обновить настрйки на сервере!', locale);
                        console.groupEnd();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var printInstruction_1 = function (title, locale) {
        console.warn(title);
        var log = function (str) { return console.log('%c %s', 'background: #000; padding: 5px 2px;', str); };
        log(storage.encode(locale));
        log("\u0412\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u0435: npm run config");
    };
}
export var get = function () {
    init();
    return storage.get();
};
var _override = {};
export function override(data) {
    if (data && typeof data === 'object') {
        _override = data;
        storage.upd(data);
    }
}
export function init() {
    return __awaiter(this, void 0, void 0, function () {
        var _a, updated, lifeTime, settings;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = storage.get(), updated = _a.updated, lifeTime = _a.lifeTime;
                    if (Date.now() - loadTime <= MS_IN_ONE_MINUTE) {
                        return [2 /*return*/];
                    }
                    if (!(Date.now() - updated > lifeTime && (PRODUCTION || !location.search.includes('useLocalSettings')))) return [3 /*break*/, 2];
                    if (DEVELOPMENT)
                        console.log('[APP:SETTINGS] Загрузка новых настроек.');
                    loadTime = Date.now();
                    return [4 /*yield*/, safeLoadSettings()];
                case 1:
                    settings = _b.sent();
                    if (settings) {
                        storage.upd(__assign(__assign(__assign({}, settings), _override), { updated: Date.now() }));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    if (DEVELOPMENT)
                        console.log('[APP:SETTINGS] Используются сохраненные настройки.');
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
function safeLoadSettings() {
    return __awaiter(this, void 0, void 0, function () {
        var res, text, _a, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(REMOTE_URL, "/").concat(REMOTE_FILE, "?t=").concat(Date.now()), { method: 'GET' })];
                case 1:
                    res = _b.sent();
                    _a = String;
                    return [4 /*yield*/, res.text()];
                case 2:
                    text = _a.apply(void 0, [_b.sent()]).trim();
                    return [2 /*return*/, storage.decode(text)];
                case 3:
                    err_1 = _b.sent();
                    Metrika.logError(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, null];
            }
        });
    });
}
